






















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { RequestService } from "@/services";
import Header from "@/components/Header.vue";
import {propertyTypes} from "@/services/properties";
import properties from "@/services/properties/danni-auto";
import data, { selectChoices } from "@/services/data/danni-auto";
import categories from "@/services/categories";
import { PnetDatePicker } from "@previnet/vue-datepicker";
import { it } from "vuejs-datepicker/dist/locale";
import { isNil } from "ramda";
import { format } from "date-fns";
import TextField from "@/components/TextField.vue";
import TextArea from "@/components/TextArea.vue";
import ComboBox from "@/components/ComboBox.vue";
import DatePicker from "@/components/DatePicker.vue";
import MultiComboBox from "@/components/MultiComboBox.vue";
import Frazionamento from "@/components/Frazionamento.vue";
import StringList from "@/components/StringList.vue";
import TextFieldSign from "@/components/TextFieldSign.vue";

const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  props: ['productId', 'user'],
  components: {
    Header,
    TextField,
    ComboBox,
    DatePicker,
    MultiComboBox,
    Frazionamento,
    StringList,
    TextFieldSign,
    TextArea,
  },
  data: function() {
    return {
      loggedUser: this.$props.user,
      errorMsg: null as any,
      okMsg: null as any,
      modalErrorMsg: null as any,
      modalErrorTitle: null as any,
      ...properties,
      ...data,
      selectChoices,
      propertyTypes,
      it,
      ND: "n.d.",
      productIdSelected: this.$props.productId,
      propList: [],
      esitoRegistrazione: null as any,
      categories,
      altroAssistenzaTipologia: null,
      altroTutelaLegaleTipologia: null,
      retrDistrField: {
        value: "",
        valueSign: "%",
      },
      massiveFile: undefined,
      massiveLoaded: false,
      massiveResult: null as any,
    };
  },
  methods: {
    isNil,
    scrollTo(refName: string) {
      var element = this.$refs[refName] as any;
      var top = element.offsetTop;
      window.scrollTo(0, top);
    },
    isEmptyOrSpaces(str: string) {
      return str === null || str.match(/^ *$/) !== null;
    },
    formatDate: function(data: Date | string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, "dd/MM/yyyy");
    },
    formatDateF: function(data: Date | string, formatStr: string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, formatStr);
    },
    dateFromString: function(value: string | Date) {
      if (typeof value !== "string" || isNil(value)) {
        return null;
      }

      const parts = value.split("/");
      if (parts.length == 3) {
        const dt = parts[1] + "/" + parts[0] + "/" + parts[2];

        const timestamp = Date.parse(dt);
        if (isNaN(timestamp) == false) {
          return new Date(timestamp);
        }
      }

      return null;
    },
    printString: function(value: string) {
      if (value === undefined || value === null || value === "") {
        return value;
      }

      const z = value.replaceAll("\n", "<br/>");
      return z;
    },
    printStringListItem(item: any) {
      return (item.valueLabel !== undefined && item.valueLabel !== null && item.valueLabel !== "" ? item.valueLabel + " " : "") + item.value + item.valueSign
    },
    home: function() {
      const vm = this as any;
      vm.$router.push({ name: 'home-prodotti', params: {user: vm.loggedUser}});
    },
    back: function() {
      const vm = this as any;
      vm.$router.go(-1);
    },
    openModalConfirm: function() {
      const vm = this as any;
      if (vm.checkFields() == true) {
        vm.valorizzaTendine();
        vm.preparePropList();

        if (vm.errorMsg == null && vm.propList.length > 0) {
          vm.$bvModal.show("modal-confirm");
        }
      }
    },
    closeModalConfirm() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm");
    },
    openModalMassivo: function() {
      const vm = this as any;
      vm.massiveFile = undefined;
      vm.massiveLoaded = false;
      vm.massiveResult = null;
      vm.$bvModal.show("modal-massive");
    },
    closeModalMassivo() {
      const vm = this as any;
      vm.$bvModal.hide("modal-massive");
    },
    openModalError(msg: any, title: any) {
      const vm = this as any;
      if (msg === undefined) {
        vm.modalErrorMsg = "Non è stato possibile salvare i dati.";
      } else {
        vm.modalErrorMsg = msg;
      }
      if (title === undefined) {
        vm.modalErrorTitle = "ERRORE";
      } else {
        vm.modalErrorTitle = title;
      }
      vm.$bvModal.show("modal-error");
    },
    closeModalError() {
      const vm = this as any;
      vm.$bvModal.hide("modal-error");
    },
    openModalConfirmOutcome() {
      const vm = this as any;
      vm.$bvModal.show("modal-confirm-outcome");
    },
    closeModalConfirmOutcome() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm-outcome");
    },
    onClickReturnConfirmOutcome() {
      const vm = this as any;
      vm.closeModalConfirmOutcome();
    },
    onClickReturnError() {
      const vm = this as any;
      vm.closeModalError();
    },
    startLoading() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");
    },
    stopLoading() {
      const vm = this as any;
      vm.$loadingService.stopLoading("loading");
    },
    multivaluesContain(multivalues: any, values: any) {
      if (multivalues != null && values != null) {
        return multivalues.filter(function(e: any) {
          return values.indexOf(e.code) >= 0;
        }).length > 0;
      }

      return false;
    },
    checkFields() {
      const vm = this as any;

      let numErr = 0;

      vm.errorMsg = null;
      vm.okMsg = null;
      if (
        properties.prodottoProperty.value == undefined ||
        properties.prodottoProperty.value == null ||
        properties.prodottoProperty.value == ""
      ) {
        vm.errorMsg =
          "Il campo " + properties.prodottoProperty.name + " deve essere valorizzato";
        numErr++;
      }

      let retValue = true;
      if (numErr > 0) {
        retValue = false;
      } else {
        vm.okMsg = "Prodotto " + properties.prodottoProperty.value + " registrato";
      }

      return retValue;
    },
    changeTariffe() {
      const vm = this as any;

      if (selectChoices.tariffe.code == '1.2b') {
        properties.codProdCollegatoProperty.value = vm.ND;
      } else {
        properties.codProdCollegatoProperty.value = "";
      }
    },
    changeFineComm() {
      const vm = this as any;
      properties.fineCommProperty.value = "";
      properties.fineCommProperty.dateValue = null;

      if (selectChoices.prodCommercio.code == "12.1") {
        properties.fineCommProperty.value = vm.ND;
      }
    },
    changePremioTipologia() {
      const vm = this as any;
      properties.frazPremioProperty.value = "";
      properties.interessiFrazProperty.value = "";

      if (!vm.multivaluesContain(selectChoices.premioTipologia, ["21.1"])) {
        selectChoices.frazPremio = [];
        properties.frazPremioProperty.value = vm.ND;
        properties.frazPremioProperty.values = [];

        properties.interessiFrazProperty.value = vm.ND;
        properties.interessiFrazProperty.frazionamento = {
          mensile: "", mensileSign: "",
          bimestrale: "", bimestraleSign: "",
          trimestrale: "", trimestraleSign: "",
          quadrimestrale: "", quadrimestraleSign: "",
          semestrale: "", semestraleSign: "",
        };
      }
    },
    countFrazionamento(prop: any) {
      const vm = this as any;
      let count = 0;

      if (prop !== undefined && prop.frazionamento !== undefined) {
        const f = prop.frazionamento;
        if (f.mensile !== vm.ND) count++;
        if (f.bimestrale !== vm.ND) count++;
        if (f.trimestrale !== vm.ND) count++;
        if (f.quadrimestrale !== vm.ND) count++;
        if (f.semestrale !== vm.ND) count++;
      }

      return count;
    },
    isInteressiFrazionamentoND() {
      const vm = this as any;
      const isPremioAnnuo = vm.multivaluesContain(selectChoices.premioTipologia, ["21.1"]);
      const isNoFraz = vm.multivaluesContain(selectChoices.frazPremio, ["23.6"]);

      return !isPremioAnnuo || isNoFraz;
    },
    isFrazionamentoMensile() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["23.1"]);
    },
    isFrazionamentoBimestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["23.2"]);
    },
    isFrazionamentoTrimestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["23.3"]);
    },
    isFrazionamentoQuadrimestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["23.4"]);
    },
    isFrazionamentoSemestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["23.5"]);
    },
    changeFrazPremio() {
      const vm = this as any;
      properties.interessiFrazProperty.value = "";

      if (selectChoices.frazPremio.length == 0 || vm.multivaluesContain(selectChoices.frazPremio, ["23.6"])) {
        properties.interessiFrazProperty.value = vm.ND;
        properties.interessiFrazProperty.frazionamento = {
          mensile: "", mensileSign: "",
          bimestrale: "", bimestraleSign: "",
          trimestrale: "", trimestraleSign: "",
          quadrimestrale: "", quadrimestraleSign: "",
          semestrale: "", semestraleSign: "",
        };
      }
    },
    changeRischi() {
      const vm = this as any;
      properties.rcTarifProperty.value = "";
      properties.rcGuidaProperty.value = "";
      properties.rcSatellitareProperty.value = "";
      properties.rcRivalsaProperty.value = "";
      properties.kaskoCollisioneProperty.value = "";
      properties.assistenzaTipologiaProperty.value = "";
      properties.tutelaLegaleTipologiaProperty.value = "";
      properties.infConducenteTipologiaProperty.value = "";

      if (!vm.multivaluesContain(selectChoices.rischi, ["27.1"])) {
        selectChoices.rcTarif = [];
        properties.rcTarifProperty.value = vm.ND;
        properties.rcTarifProperty.values = [];
  
        selectChoices.rcGuida = [];
        properties.rcGuidaProperty.value = vm.ND;
        properties.rcGuidaProperty.values = [];
  
        selectChoices.rcSatellitare.code = "";
        selectChoices.rcSatellitare.description = "";
        properties.rcSatellitareProperty.value = vm.ND;

        selectChoices.rcRivalsa = [];
        properties.rcRivalsaProperty.value = vm.ND;
        properties.rcRivalsaProperty.values = [];

        properties.rivalsaAcquistoProperty.value = vm.ND;
        properties.rcMeritoProperty.value = vm.ND;
        properties.rcSpecificaProperty.value = vm.ND;
        properties.rcSospensioneProperty.value = vm.ND;
        properties.rcRicorsoProperty.value = vm.ND;        
      } else {
        if (properties.rivalsaAcquistoProperty.value == vm.ND) {
          properties.rivalsaAcquistoProperty.value = "";
        }
        if (properties.rcMeritoProperty.value == vm.ND) {
          properties.rcMeritoProperty.value = "";
        }
        if (properties.rcSpecificaProperty.value == vm.ND) {
          properties.rcSpecificaProperty.value = "";
        }
        if (properties.rcSospensioneProperty.value == vm.ND) {
          properties.rcSospensioneProperty.value = "";
        }
        if (properties.rcRicorsoProperty.value == vm.ND) {
          properties.rcRicorsoProperty.value = "";
        }
      }

      if (!vm.multivaluesContain(selectChoices.rischi, ["27.2"])) {
        properties.ifIncendioProperty.value = vm.ND;
        properties.ifFurtoProperty.value = vm.ND;
        properties.ifVincoliProperty.value = vm.ND;
        properties.ifTotaleProperty.value = vm.ND;
        properties.ifParzialeProperty.value = vm.ND;
        properties.ifProporzionaleProperty.value = vm.ND;
        properties.ifTerziProperty.value = vm.ND;
      } else {
        if (properties.ifIncendioProperty.value == vm.ND) {
          properties.ifIncendioProperty.value = "";
        }
        if (properties.ifFurtoProperty.value == vm.ND) {
          properties.ifFurtoProperty.value = "";
        }
        if (properties.ifVincoliProperty.value == vm.ND) {
          properties.ifVincoliProperty.value = "";
        }
        if (properties.ifTotaleProperty.value == vm.ND) {
          properties.ifTotaleProperty.value = "";
        }
        if (properties.ifParzialeProperty.value == vm.ND) {
          properties.ifParzialeProperty.value = "";
        }
        if (properties.ifProporzionaleProperty.value == vm.ND) {
          properties.ifProporzionaleProperty.value = "";
        }
        if (properties.ifTerziProperty.value == vm.ND) {
          properties.ifTerziProperty.value = "";
        }
      }

      if (!vm.multivaluesContain(selectChoices.rischi, ["27.3"])) {
        selectChoices.kaskoCollisione = [];
        properties.kaskoCollisioneProperty.value = vm.ND;
        properties.kaskoCollisioneProperty.values = [];
      }

      if (!vm.multivaluesContain(selectChoices.rischi, ["27.4"])) {
        properties.attiVandaliciEventiProperty.value = vm.ND;
        properties.attiVandaliciVincoliProperty.value = vm.ND;
        properties.attiVandaliciFranchigieProperty.value = vm.ND;
      } else {
        if (properties.attiVandaliciEventiProperty.value == vm.ND) {
          properties.attiVandaliciEventiProperty.value = "";
        }
        if (properties.attiVandaliciVincoliProperty.value == vm.ND) {
          properties.attiVandaliciVincoliProperty.value = "";
        }
        if (properties.attiVandaliciFranchigieProperty.value == vm.ND) {
          properties.attiVandaliciFranchigieProperty.value = "";
        }
      }

      if (!vm.multivaluesContain(selectChoices.rischi, ["27.5"])) {
        properties.eventiNaturaliEventiProperty.value = vm.ND;
        properties.eventiNaturaliVincoliProperty.value = vm.ND;
        properties.eventiNaturaliFranchigieProperty.value = vm.ND;
      } else {
        if (properties.eventiNaturaliEventiProperty.value == vm.ND) {
          properties.eventiNaturaliEventiProperty.value = "";
        }
        if (properties.eventiNaturaliVincoliProperty.value == vm.ND) {
          properties.eventiNaturaliVincoliProperty.value = "";
        }
        if (properties.eventiNaturaliFranchigieProperty.value == vm.ND) {
          properties.eventiNaturaliFranchigieProperty.value = "";
        }
      }

      if (!vm.multivaluesContain(selectChoices.rischi, ["27.6"])) {
        properties.eventiSociopoliticiEventiProperty.value = vm.ND;
        properties.eventiSociopoliticiVincoliProperty.value = vm.ND;
        properties.eventiSociopoliticiFranchigieProperty.value = vm.ND;
      } else {
        if (properties.eventiSociopoliticiEventiProperty.value == vm.ND) {
          properties.eventiSociopoliticiEventiProperty.value = "";
        }
        if (properties.eventiSociopoliticiVincoliProperty.value == vm.ND) {
          properties.eventiSociopoliticiVincoliProperty.value = "";
        }
        if (properties.eventiSociopoliticiFranchigieProperty.value == vm.ND) {
          properties.eventiSociopoliticiFranchigieProperty.value = "";
        }
      }

      if (!vm.multivaluesContain(selectChoices.rischi, ["27.7"])) {
        properties.cristalliEventiProperty.value = vm.ND;
        properties.cristalliVincoliProperty.value = vm.ND;
        properties.cristalliMassimaliProperty.value = vm.ND;
        properties.cristalliFranchigieProperty.value = vm.ND;
      } else {
        if (properties.cristalliEventiProperty.value == vm.ND) {
          properties.cristalliEventiProperty.value = "";
        }
        if (properties.cristalliVincoliProperty.value == vm.ND) {
          properties.cristalliVincoliProperty.value = "";
        }
        if (properties.cristalliMassimaliProperty.value == vm.ND) {
          properties.cristalliMassimaliProperty.value = "";
        }
        if (properties.cristalliFranchigieProperty.value == vm.ND) {
          properties.cristalliFranchigieProperty.value = "";
        }
      }

      if (!vm.multivaluesContain(selectChoices.rischi, ["27.8"])) {
        selectChoices.assistenzaTipologia = [];
        properties.assistenzaTipologiaProperty.value = vm.ND;
        properties.assistenzaTipologiaProperty.values = [];

        properties.assistenzaFormeProperty.value = vm.ND;
        properties.assistenzaMassimaliProperty.value = vm.ND;
        properties.assistenzaOutsourcingProperty.value = vm.ND;
      } else {
        if (properties.assistenzaFormeProperty.value == vm.ND) {
          properties.assistenzaFormeProperty.value = "";
        }
        if (properties.assistenzaMassimaliProperty.value == vm.ND) {
          properties.assistenzaMassimaliProperty.value = "";
        }
        if (properties.assistenzaOutsourcingProperty.value == vm.ND) {
          properties.assistenzaOutsourcingProperty.value = "";
        }
      }

      if (!vm.multivaluesContain(selectChoices.rischi, ["27.9"])) {
        selectChoices.tutelaLegaleTipologia = [];
        properties.tutelaLegaleTipologiaProperty.value = vm.ND;
        properties.tutelaLegaleTipologiaProperty.values = [];

        properties.tutelaLegaleFormeProperty.value = vm.ND;
        properties.tutelaLegaleMassimaliProperty.value = vm.ND;
        properties.tutelaLegaleOutsourcingProperty.value = vm.ND;
      } else {
        if (properties.tutelaLegaleFormeProperty.value == vm.ND) {
          properties.tutelaLegaleFormeProperty.value = "";
        }
        if (properties.tutelaLegaleMassimaliProperty.value == vm.ND) {
          properties.tutelaLegaleMassimaliProperty.value = "";
        }
        if (properties.tutelaLegaleOutsourcingProperty.value == vm.ND) {
          properties.tutelaLegaleOutsourcingProperty.value = "";
        }
      }

      if (!vm.multivaluesContain(selectChoices.rischi, ["27.10"])) {
        selectChoices.infConducenteTipologia = [];
        properties.infConducenteTipologiaProperty.value = vm.ND;
        properties.infConducenteTipologiaProperty.values = [];

        properties.infConducenteLimitiProperty.value = vm.ND;
      } else {
        if (properties.infConducenteLimitiProperty.value == vm.ND) {
          properties.infConducenteLimitiProperty.value = "";
        }
      }

      if (!vm.multivaluesContain(selectChoices.rischi, ["27.11"])) {
        properties.altreGaranzieProperty.value = vm.ND;
      } else {
        if (properties.altreGaranzieProperty.value == vm.ND) {
          properties.altreGaranzieProperty.value = "";
        }
      }

      vm.changeGuida();
      vm.changeSatellitare();
      vm.changeRivalsa();
      vm.changeKasko();
      vm.changeInfortuni();
    },
    changeGuida() {
      const vm = this as any;

      if (!vm.multivaluesContain(selectChoices.rcGuida, ["29.1"])) {
        properties.guidaLiberaProperty.value = vm.ND;
      } else if (properties.guidaLiberaProperty.value == vm.ND) {
        properties.guidaLiberaProperty.value = "";
      }
      if (!vm.multivaluesContain(selectChoices.rcGuida, ["29.2"])) {
        properties.guidaEspertaProperty.value = vm.ND;
      } else if (properties.guidaEspertaProperty.value == vm.ND) {
        properties.guidaEspertaProperty.value = "";
      }
      if (!vm.multivaluesContain(selectChoices.rcGuida, ["29.3"])) {
        properties.guidaEsclusivaProperty.value = vm.ND;
      } else if (properties.guidaEsclusivaProperty.value == vm.ND) {
        properties.guidaEsclusivaProperty.value = "";
      }
    },
    changeSatellitare() {
      const vm = this as any;

      if (selectChoices.rcSatellitare.code == "" || selectChoices.rcSatellitare.code == "33.3") {
        properties.satOutsourcingProperty.value = vm.ND;
        properties.satProprietaProperty.value = vm.ND;
        properties.satServiziProperty.value = vm.ND;
        properties.satScontiProperty.value = vm.ND;
      } else {
        if (properties.satOutsourcingProperty.value == vm.ND) {
          properties.satOutsourcingProperty.value = "";
        }
        if (properties.satProprietaProperty.value == vm.ND) {
          properties.satProprietaProperty.value = "";
        }
        if (properties.satServiziProperty.value == vm.ND) {
          properties.satServiziProperty.value = "";
        }
        if (properties.satScontiProperty.value == vm.ND) {
          properties.satScontiProperty.value = "";
        }
      }
    },
    changeRivalsa() {
      const vm = this as any;

      if (!vm.multivaluesContain(selectChoices.rcRivalsa, ["38.1"])) {
        properties.rivalsaEbrezzaProperty.value = vm.ND;
      } else if (properties.rivalsaEbrezzaProperty.value == vm.ND) {
        properties.rivalsaEbrezzaProperty.value = "";
      }
      if (!vm.multivaluesContain(selectChoices.rcRivalsa, ["38.2"])) {
        properties.rivalsaStupefacentiProperty.value = vm.ND;
      } else if (properties.rivalsaStupefacentiProperty.value == vm.ND) {
        properties.rivalsaStupefacentiProperty.value = "";
      }
      if (!vm.multivaluesContain(selectChoices.rcRivalsa, ["38.3"])) {
        properties.rivalsaTerziProperty.value = vm.ND;
      } else if (properties.rivalsaTerziProperty.value == vm.ND) {
        properties.rivalsaTerziProperty.value = "";
      }
      if (!vm.multivaluesContain(selectChoices.rcRivalsa, ["38.4"])) {
        properties.rivalsaPatenteProperty.value = vm.ND;
      } else if (properties.rivalsaPatenteProperty.value == vm.ND) {
        properties.rivalsaPatenteProperty.value = "";
      }
      if (!vm.multivaluesContain(selectChoices.rcRivalsa, ["38.5"])) {
        properties.rivalsaMinoriProperty.value = vm.ND;
      } else if (properties.rivalsaMinoriProperty.value == vm.ND) {
        properties.rivalsaMinoriProperty.value = "";
      }
      if (!vm.multivaluesContain(selectChoices.rcRivalsa, ["38.6"])) {
        properties.rivalsaRevisioneProperty.value = vm.ND;
      } else if (properties.rivalsaRevisioneProperty.value == vm.ND) {
        properties.rivalsaRevisioneProperty.value = "";
      }
      if (!vm.multivaluesContain(selectChoices.rcRivalsa, ["38.7"])) {
        properties.rivalsaNeopatentatiProperty.value = vm.ND;
      } else if (properties.rivalsaNeopatentatiProperty.value == vm.ND) {
        properties.rivalsaNeopatentatiProperty.value = "";
      }
    },
    changeKasko() {
      const vm = this as any;

      if (!vm.multivaluesContain(selectChoices.kaskoCollisione, ["56.1"])) {
        properties.collPlafDenominazioneProperty.value = vm.ND;
        properties.collPlafEventiProperty.value = vm.ND;
        properties.collPlafVincoliProperty.value = vm.ND;
        properties.collPlafMassimaliProperty.value = vm.ND;
        properties.collPlafFranchigieProperty.value = vm.ND;
      } else {
        if (properties.collPlafDenominazioneProperty.value == vm.ND) {
          properties.collPlafDenominazioneProperty.value = "";
        }
        if (properties.collPlafEventiProperty.value == vm.ND) {
          properties.collPlafEventiProperty.value = "";
        }
        if (properties.collPlafVincoliProperty.value == vm.ND) {
          properties.collPlafVincoliProperty.value = "";
        }
        if (properties.collPlafMassimaliProperty.value == vm.ND) {
          properties.collPlafMassimaliProperty.value = "";
        }
        if (properties.collPlafFranchigieProperty.value == vm.ND) {
          properties.collPlafFranchigieProperty.value = "";
        }
      } 
      if (!vm.multivaluesContain(selectChoices.kaskoCollisione, ["56.2"])) {
        properties.collEventiProperty.value = vm.ND;
        properties.collVincoliProperty.value = vm.ND;
        properties.collTotaleProperty.value = vm.ND;
        properties.collParzialeProperty.value = vm.ND;
        properties.collFranchigieProperty.value = vm.ND;
      } else {
        if (properties.collEventiProperty.value == vm.ND) {
          properties.collEventiProperty.value = "";
        }
        if (properties.collVincoliProperty.value == vm.ND) {
          properties.collVincoliProperty.value = "";
        }
        if (properties.collTotaleProperty.value == vm.ND) {
          properties.collTotaleProperty.value = "";
        }
        if (properties.collParzialeProperty.value == vm.ND) {
          properties.collParzialeProperty.value = "";
        }
        if (properties.collFranchigieProperty.value == vm.ND) {
          properties.collFranchigieProperty.value = "";
        }
      } 
      if (!vm.multivaluesContain(selectChoices.kaskoCollisione, ["56.3"])) {
        properties.kaskoEventiProperty.value = vm.ND;
        properties.kaskoVincoliProperty.value = vm.ND;
        properties.kaskoTotaleProperty.value = vm.ND;
        properties.kaskoParzialeProperty.value = vm.ND;
        properties.kaskoFranchigieProperty.value = vm.ND;
      } else {
        if (properties.kaskoEventiProperty.value == vm.ND) {
          properties.kaskoEventiProperty.value = "";
        }
        if (properties.kaskoVincoliProperty.value == vm.ND) {
          properties.kaskoVincoliProperty.value = "";
        }
        if (properties.kaskoTotaleProperty.value == vm.ND) {
          properties.kaskoTotaleProperty.value = "";
        }
        if (properties.kaskoParzialeProperty.value == vm.ND) {
          properties.kaskoParzialeProperty.value = "";
        }
        if (properties.kaskoFranchigieProperty.value == vm.ND) {
          properties.kaskoFranchigieProperty.value = "";
        }
      } 
    },
    changeInfortuni() {
      const vm = this as any;

      if (!vm.multivaluesContain(selectChoices.infConducenteTipologia, ["95.1"])) {
        properties.infMorteVincoliProperty.value = vm.ND;
        properties.infMorteMassimaliProperty.value = vm.ND;
        properties.infMorteFranchigieProperty.value = vm.ND;
      } else {
        if (properties.infMorteVincoliProperty.value == vm.ND) {
          properties.infMorteVincoliProperty.value = "";
        }
        if (properties.infMorteMassimaliProperty.value == vm.ND) {
          properties.infMorteMassimaliProperty.value = "";
        }
        if (properties.infMorteFranchigieProperty.value == vm.ND) {
          properties.infMorteFranchigieProperty.value = "";
        }
      } 

      if (!vm.multivaluesContain(selectChoices.infConducenteTipologia, ["95.2"])) {
        selectChoices.infInvTabella.code = "";
        selectChoices.infInvTabella.description = "";
        properties.infInvTabellaProperty.value = vm.ND;

        properties.infInvVincoliProperty.value = vm.ND;
        properties.infInvMassimaliProperty.value = vm.ND;
        properties.infInvFranchigieProperty.value = vm.ND;
        properties.infInvSopravalutazioneProperty.value = vm.ND;
      } else {
        properties.infInvTabellaProperty.value = "";
        if (properties.infInvVincoliProperty.value == vm.ND) {
          properties.infInvVincoliProperty.value = "";
        }
        if (properties.infInvMassimaliProperty.value == vm.ND) {
          properties.infInvMassimaliProperty.value = "";
        }
        if (properties.infInvFranchigieProperty.value == vm.ND) {
          properties.infInvFranchigieProperty.value = "";
        }
        if (properties.infInvSopravalutazioneProperty.value == vm.ND) {
          properties.infInvSopravalutazioneProperty.value = "";
        }
      } 

      if (!vm.multivaluesContain(selectChoices.infConducenteTipologia, ["95.3"])) {
        properties.infDiariaVincoliProperty.value = vm.ND;
        properties.infDiariaMassimaliProperty.value = vm.ND;
        properties.infDiariaFranchigieProperty.value = vm.ND;
      } else {
        if (properties.infDiariaVincoliProperty.value == vm.ND) {
          properties.infDiariaVincoliProperty.value = "";
        }
        if (properties.infDiariaMassimaliProperty.value == vm.ND) {
          properties.infDiariaMassimaliProperty.value = "";
        }
        if (properties.infDiariaFranchigieProperty.value == vm.ND) {
          properties.infDiariaFranchigieProperty.value = "";
        }
      } 

      if (!vm.multivaluesContain(selectChoices.infConducenteTipologia, ["95.4"])) {
        properties.rimbSpeseGenericheVincoliProperty.value = vm.ND;
        properties.rimbSpeseGenericheMassimaliProperty.value = vm.ND;
        properties.rimbSpeseGenericheFranchigieProperty.value = vm.ND;
      } else {
        if (properties.rimbSpeseGenericheVincoliProperty.value == vm.ND) {
          properties.rimbSpeseGenericheVincoliProperty.value = "";
        }
        if (properties.rimbSpeseGenericheMassimaliProperty.value == vm.ND) {
          properties.rimbSpeseGenericheMassimaliProperty.value = "";
        }
        if (properties.rimbSpeseGenericheFranchigieProperty.value == vm.ND) {
          properties.rimbSpeseGenericheFranchigieProperty.value = "";
        }
      } 

      if (!vm.multivaluesContain(selectChoices.infConducenteTipologia, ["95.5"])) {
        properties.rimbSpeseInterventoVincoliProperty.value = vm.ND;
        properties.rimbSpeseInterventoMassimaliProperty.value = vm.ND;
        properties.rimbSpeseInterventoFranchigieProperty.value = vm.ND;
      } else {
        if (properties.rimbSpeseInterventoVincoliProperty.value == vm.ND) {
          properties.rimbSpeseInterventoVincoliProperty.value = "";
        }
        if (properties.rimbSpeseInterventoMassimaliProperty.value == vm.ND) {
          properties.rimbSpeseInterventoMassimaliProperty.value = "";
        }
        if (properties.rimbSpeseInterventoFranchigieProperty.value == vm.ND) {
          properties.rimbSpeseInterventoFranchigieProperty.value = "";
        }
      } 

      if (!vm.multivaluesContain(selectChoices.infConducenteTipologia, ["95.6"])) {
        properties.rimbSpeseRicoveroVincoliProperty.value = vm.ND;
        properties.rimbSpeseRicoveroMassimaliProperty.value = vm.ND;
        properties.rimbSpeseRicoveroFranchigieProperty.value = vm.ND;
      } else {
        if (properties.rimbSpeseRicoveroVincoliProperty.value == vm.ND) {
          properties.rimbSpeseRicoveroVincoliProperty.value = "";
        }
        if (properties.rimbSpeseRicoveroMassimaliProperty.value == vm.ND) {
          properties.rimbSpeseRicoveroMassimaliProperty.value = "";
        }
        if (properties.rimbSpeseRicoveroFranchigieProperty.value == vm.ND) {
          properties.rimbSpeseRicoveroFranchigieProperty.value = "";
        }
      } 

      if (!vm.multivaluesContain(selectChoices.infConducenteTipologia, ["95.7"])) {
        properties.infMobilitaVincoliProperty.value = vm.ND;
        properties.infMobilitaMassimaliProperty.value = vm.ND;
        properties.infMobilitaFranchigieProperty.value = vm.ND;
      } else {
        if (properties.infMobilitaVincoliProperty.value == vm.ND) {
          properties.infMobilitaVincoliProperty.value = "";
        }
        if (properties.infMobilitaMassimaliProperty.value == vm.ND) {
          properties.infMobilitaMassimaliProperty.value = "";
        }
        if (properties.infMobilitaFranchigieProperty.value == vm.ND) {
          properties.infMobilitaFranchigieProperty.value = "";
        }
      } 

      if (!vm.multivaluesContain(selectChoices.infConducenteTipologia, ["95.8"])) {
        properties.inabilitaVincoliProperty.value = vm.ND;
        properties.inabilitaMassimaliProperty.value = vm.ND;
        properties.inabilitaFranchigieProperty.value = vm.ND;
      } else {
        if (properties.inabilitaVincoliProperty.value == vm.ND) {
          properties.inabilitaVincoliProperty.value = "";
        }
        if (properties.inabilitaMassimaliProperty.value == vm.ND) {
          properties.inabilitaMassimaliProperty.value = "";
        }
        if (properties.inabilitaFranchigieProperty.value == vm.ND) {
          properties.inabilitaFranchigieProperty.value = "";
        }
      } 

      if (!vm.multivaluesContain(selectChoices.infConducenteTipologia, ["95.9"])) {
        properties.infConducenteAltroProperty.value = vm.ND;
      } else {
        if (properties.infConducenteAltroProperty.value == vm.ND) {
          properties.infConducenteAltroProperty.value = "";
        }
      } 
    },
    valorizzaTendine() {
      const vm = this as any;

      properties.tariffeProperty.code = selectChoices.tariffe.code;
      properties.tariffeProperty.value = selectChoices.tariffe.description;
      properties.compagniaProperty.code = selectChoices.compagnia.code;
      properties.compagniaProperty.value = selectChoices.compagnia.description;
      properties.canaleProperty.values = selectChoices.canale;
      properties.modDistribuzioneProperty.values = selectChoices.modDistribuzione;
      properties.mercatoProperty.values = selectChoices.mercato;
      properties.veicoliProperty.code = selectChoices.veicoli.code;
      properties.veicoliProperty.value = selectChoices.veicoli.description;
      properties.prodCommercioProperty.code = selectChoices.prodCommercio.code;
      properties.prodCommercioProperty.value = selectChoices.prodCommercio.description;
      properties.tipoAssicurazioneProperty.code = selectChoices.tipoAssicurazione.code;
      properties.tipoAssicurazioneProperty.value = selectChoices.tipoAssicurazione.description;
      properties.combGaranzieTipologiaProperty.code = selectChoices.combGaranzieTipologia.code;
      properties.combGaranzieTipologiaProperty.value = selectChoices.combGaranzieTipologia.description;
      properties.premioTipologiaProperty.values = selectChoices.premioTipologia;
      properties.frazPremioProperty.values = selectChoices.frazPremio;
      properties.rischiProperty.values = selectChoices.rischi;
      properties.rcTarifProperty.values = selectChoices.rcTarif;
      properties.rcGuidaProperty.values = selectChoices.rcGuida;
      if (properties.rcSatellitareProperty.value !== vm.ND) {
        properties.rcSatellitareProperty.code = selectChoices.rcSatellitare.code;
        properties.rcSatellitareProperty.value = selectChoices.rcSatellitare.description;
      }
      properties.rcRivalsaProperty.values = selectChoices.rcRivalsa;
      properties.kaskoCollisioneProperty.values = selectChoices.kaskoCollisione;
      properties.assistenzaTipologiaProperty.values = selectChoices.assistenzaTipologia;
      properties.tutelaLegaleTipologiaProperty.values = selectChoices.tutelaLegaleTipologia;
      properties.infConducenteTipologiaProperty.values = selectChoices.infConducenteTipologia;
      if (properties.infInvTabellaProperty.value !== vm.ND) {
        properties.infInvTabellaProperty.code = selectChoices.infInvTabella.code;
        properties.infInvTabellaProperty.value = selectChoices.infInvTabella.description;
      }
    },
    cleanAllProperties() {
      const vm = this as any;

      properties.prodottoProperty.value = "";
      properties.tariffeProperty.code = ""; properties.tariffeProperty.value = "";
      properties.codProdCollegatoProperty.value = "";
      properties.compagniaProperty.code = ""; properties.compagniaProperty.value = "";
      properties.canaleProperty.values = [];
      properties.distributoriProperty.value = "";
      properties.distributoriProperty.stringList = [{ value: "", valueSign: "" }];
      properties.modDistribuzioneProperty.values = [];
      properties.mercatoProperty.values = [];
      properties.destinatariProperty.value = "";
      properties.targetMarketProperty.value = "";
      properties.descProdottoProperty.value = "";
      properties.lineaBusinessProperty.value = "Veicoli";
      properties.veicoliProperty.code = ""; properties.veicoliProperty.value = "";
      properties.prodCommercioProperty.code = ""; properties.prodCommercioProperty.value = "";
      properties.inizioCommProperty.value = ""; properties.inizioCommProperty.dateValue = null;
      properties.fineCommProperty.value = ""; properties.fineCommProperty.dateValue = null;
      properties.edizioneDIPAggProperty.value = ""; properties.edizioneDIPAggProperty.dateValue = null;
      properties.tipoAssicurazioneProperty.code = ""; properties.tipoAssicurazioneProperty.value = "";
      properties.durataProperty.value = "";
      properties.tacitoRinnovoProperty.value = "";
      properties.combGaranzieTipologiaProperty.code = ""; properties.combGaranzieTipologiaProperty.value = "";
      properties.combGaranzieDescProperty.value = "";
      properties.premioTipologiaProperty.values = [];
      properties.premioDescProperty.value = "";
      properties.frazPremioProperty.values = [];
      properties.interessiFrazProperty.value = "";
      properties.interessiFrazProperty.frazionamento = {
        mensile: "", mensileSign: "",
        bimestrale: "", bimestraleSign: "",
        trimestrale: "", trimestraleSign: "",
        quadrimestrale: "", quadrimestraleSign: "",
        semestrale: "", semestraleSign: "",
      };
      properties.retrDistrProperty.value = "";
      properties.retrDistrSpecificheProperty.value = "";
      properties.rischiProperty.values = [];
      properties.rcTarifProperty.values = [];
      properties.rcGuidaProperty.values = [];
      properties.guidaLiberaProperty.value = "";
      properties.guidaEspertaProperty.value = "";
      properties.guidaEsclusivaProperty.value = "";
      properties.rcSatellitareProperty.code = ""; properties.rcSatellitareProperty.value = "";
      properties.satOutsourcingProperty.value = "";
      properties.satProprietaProperty.value = "";
      properties.satServiziProperty.value = "";
      properties.satScontiProperty.value = "";
      properties.rcRivalsaProperty.values = [];
      properties.rivalsaEbrezzaProperty.value = "";
      properties.rivalsaStupefacentiProperty.value = "";
      properties.rivalsaTerziProperty.value = "";
      properties.rivalsaPatenteProperty.value = "";
      properties.rivalsaMinoriProperty.value = "";
      properties.rivalsaRevisioneProperty.value = "";
      properties.rivalsaNeopatentatiProperty.value = "";
      properties.rivalsaAcquistoProperty.value = "";
      properties.rcMeritoProperty.value = "";
      properties.rcSpecificaProperty.value = "";
      properties.rcSospensioneProperty.value = "";
      properties.rcRicorsoProperty.value = "";
      properties.ifIncendioProperty.value = "";
      properties.ifFurtoProperty.value = "";
      properties.ifVincoliProperty.value = "";
      properties.ifTotaleProperty.value = "";
      properties.ifParzialeProperty.value = "";
      properties.ifProporzionaleProperty.value = "";
      properties.ifTerziProperty.value = "";
      properties.kaskoCollisioneProperty.values = [];
      properties.collPlafDenominazioneProperty.value = "";
      properties.collPlafEventiProperty.value = "";
      properties.collPlafVincoliProperty.value = "";
      properties.collPlafMassimaliProperty.value = "";
      properties.collPlafFranchigieProperty.value = "";
      properties.collEventiProperty.value = "";
      properties.collVincoliProperty.value = "";
      properties.collTotaleProperty.value = "";
      properties.collParzialeProperty.value = "";
      properties.collFranchigieProperty.value = "";
      properties.kaskoEventiProperty.value = "";
      properties.kaskoVincoliProperty.value = "";
      properties.kaskoTotaleProperty.value = "";
      properties.kaskoParzialeProperty.value = "";
      properties.kaskoFranchigieProperty.value = "";
      properties.attiVandaliciEventiProperty.value = "";
      properties.attiVandaliciVincoliProperty.value = "";
      properties.attiVandaliciFranchigieProperty.value = "";
      properties.eventiNaturaliEventiProperty.value = "";
      properties.eventiNaturaliVincoliProperty.value = "";
      properties.eventiNaturaliFranchigieProperty.value = "";
      properties.eventiSociopoliticiEventiProperty.value = "";
      properties.eventiSociopoliticiVincoliProperty.value = "";
      properties.eventiSociopoliticiFranchigieProperty.value = "";
      properties.cristalliEventiProperty.value = "";
      properties.cristalliVincoliProperty.value = "";
      properties.cristalliMassimaliProperty.value = "";
      properties.cristalliFranchigieProperty.value = "";
      properties.assistenzaTipologiaProperty.values = [];
      properties.assistenzaFormeProperty.value = "";
      properties.assistenzaMassimaliProperty.value = "";
      properties.assistenzaOutsourcingProperty.value = "";
      properties.tutelaLegaleTipologiaProperty.values = [];
      properties.tutelaLegaleFormeProperty.value = "";
      properties.tutelaLegaleMassimaliProperty.value = "";
      properties.tutelaLegaleOutsourcingProperty.value = "";
      properties.infConducenteTipologiaProperty.values = [];
      properties.infConducenteLimitiProperty.value = "";
      properties.infMorteVincoliProperty.value = "";
      properties.infMorteMassimaliProperty.value = "";
      properties.infMorteFranchigieProperty.value = "";
      properties.infInvTabellaProperty.code = ""; properties.infInvTabellaProperty.value = "";
      properties.infInvVincoliProperty.value = "";
      properties.infInvMassimaliProperty.value = "";
      properties.infInvFranchigieProperty.value = "";
      properties.infInvSopravalutazioneProperty.value = "";
      properties.infDiariaVincoliProperty.value = "";
      properties.infDiariaMassimaliProperty.value = "";
      properties.infDiariaFranchigieProperty.value = "";
      properties.rimbSpeseGenericheVincoliProperty.value = "";
      properties.rimbSpeseGenericheMassimaliProperty.value = "";
      properties.rimbSpeseGenericheFranchigieProperty.value = "";
      properties.rimbSpeseInterventoVincoliProperty.value = "";
      properties.rimbSpeseInterventoMassimaliProperty.value = "";
      properties.rimbSpeseInterventoFranchigieProperty.value = "";
      properties.rimbSpeseRicoveroVincoliProperty.value = "";
      properties.rimbSpeseRicoveroMassimaliProperty.value = "";
      properties.rimbSpeseRicoveroFranchigieProperty.value = "";
      properties.infMobilitaVincoliProperty.value = "";
      properties.infMobilitaMassimaliProperty.value = "";
      properties.infMobilitaFranchigieProperty.value = "";
      properties.inabilitaVincoliProperty.value = "";
      properties.inabilitaMassimaliProperty.value = "";
      properties.inabilitaFranchigieProperty.value = "";
      properties.infConducenteAltroProperty.value = "";
      properties.altreGaranzieProperty.value = "";
      properties.innovazioneProperty.value = "";
      properties.noteProperty.value = "";

      selectChoices.tariffe = { code: "", description: "" };
      selectChoices.compagnia = { code: "", description: "" };
      selectChoices.canale = [];
      selectChoices.modDistribuzione = [];
      selectChoices.mercato = [];
      selectChoices.veicoli = { code: "", description: "" };
      selectChoices.prodCommercio = { code: "", description: "" };
      selectChoices.tipoAssicurazione = { code: "", description: "" };
      selectChoices.combGaranzieTipologia = { code: "", description: "" };
      selectChoices.premioTipologia = [];
      selectChoices.frazPremio = [];
      selectChoices.rischi = [];
      selectChoices.rcTarif = [];
      selectChoices.rcGuida = [];
      selectChoices.rcSatellitare = { code: "", description: "" };
      selectChoices.rcRivalsa = [];
      selectChoices.kaskoCollisione = [];
      selectChoices.assistenzaTipologia = [];
      selectChoices.tutelaLegaleTipologia = [];
      selectChoices.infConducenteTipologia = [];
      selectChoices.infInvTabella = { code: "", description: "" };
    },
    setPropertiesDefaultCode() {
      if (properties.tariffeProperty.code === "") { properties.tariffeProperty.code = "1b"; }
      if (properties.compagniaProperty.code === "") { properties.compagniaProperty.code = "2"; }
      if (properties.veicoliProperty.code === "") { properties.veicoliProperty.code = "11"; }
      if (properties.prodCommercioProperty.code === "") { properties.prodCommercioProperty.code = "12"; }
      if (properties.tipoAssicurazioneProperty.code === "") { properties.tipoAssicurazioneProperty.code = "16"; }
      if (properties.combGaranzieTipologiaProperty.code === "") { properties.combGaranzieTipologiaProperty.code = "19"; }
      if (properties.rcSatellitareProperty.code === "") { properties.rcSatellitareProperty.code = "33"; }
      if (properties.infInvTabellaProperty.code === "") { properties.infInvTabellaProperty.code = "100"; }
    },
    prefillCodeValue: function(property: any, propCode: string, propValue: string, choices: any, options: any []) {
      property.code = propCode;
      property.value = propValue;
      if (propCode.match(/\./)) {
        const v = options.find((o: any) => o.code === propCode);
        choices = { code: propCode, description: v ? v.description : propValue };
      } else {
        choices = { code: '', description: '' };
      }

      return choices;
    },
    prefillValues: function(property: any, values: any [], choices: any, options: any []) {
      property.values = values;
      if (values.length > 0) {
        choices = [];
        for (let i = 0; i < values.length; i++) {
          const v = options.find((o: any) => o.code === values[i].code);
          choices.push({ code: v.code, description: v.description});
        }
      } else {
        choices = [];
      }

      return choices;
    },
    prefillProperties: async function() {
      const vm = this as any;
      
      // se si arriva da Database.vue bisogna prefillare i campi
      if (vm.productIdSelected != undefined) {
        vm.startLoading();

        const serviceCallReturnValue = await requestService
          .getProduct(vm.productIdSelected)
          .then(handleResponse)
          .then((result: any) => {
            const prodotto = result.properties[0].value;
            const tariffeCode = result.properties[1].code;
            const tariffeValue = result.properties[1].value;
            const codProdCollegato = result.properties[2].value;
            const compagniaCode = result.properties[3].code;
            const compagniaValue = result.properties[3].value;
            const canaleValue = result.properties[4].value;
            const canaleValues = result.properties[4].values;
            const distributoriStringList = result.properties[5].stringList;
            const modDistribuzioneValue = result.properties[6].value;
            const modDistribuzioneValues = result.properties[6].values;
            const mercatoValue = result.properties[7].value;
            const mercatoValues = result.properties[7].values;
            const destinatari = result.properties[8].value;
            const targetMarket = result.properties[9].value;
            const descProdotto = result.properties[10].value;
            const lineaBusiness = result.properties[11].value;
            const veicoliCode = result.properties[12].code;
            const veicoliValue = result.properties[12].value;
            const combGaranzieTipologiaCode = result.properties[13].code;
            const combGaranzieTipologiaValue = result.properties[13].value;
            const combGaranzieDesc = result.properties[14].value;
            const prodCommercioCode = result.properties[15].code;
            const prodCommercioValue = result.properties[15].value;
            const inizioComm = result.properties[16].value;
            const fineComm = result.properties[17].value;
            const edizioneDIPAgg = result.properties[18].value;
            const tipoAssicurazioneCode = result.properties[19].code;
            const tipoAssicurazioneValue = result.properties[19].value;
            const durata = result.properties[20].value;
            const tacitoRinnovo = result.properties[21].value;
            const premioTipologiaValue = result.properties[22].value;
            const premioTipologiaValues = result.properties[22].values;
            const premioDesc = result.properties[23].value;
            const frazPremioValue = result.properties[24].value;
            const frazPremioValues = result.properties[24].values;
            const interessiFrazValue = result.properties[25].value;
            const interessiFrazFrazionamento = result.properties[25].frazionamento;
            const retrDistr = result.properties[26].value;
            let retrDistrSign = result.properties[26].valueSign;
            const retrDistrSpecifiche = result.properties[27].value;
            const rischiValue = result.properties[28].value;
            const rischiValues = result.properties[28].values;
            const rcTarifValue = result.properties[29].value;
            const rcTarifValues = result.properties[29].values;
            const rcGuidaValue = result.properties[30].value;
            const rcGuidaValues = result.properties[30].values;
            const guidaLibera = result.properties[31].value;
            const guidaEsperta = result.properties[32].value;
            const guidaEsclusiva = result.properties[33].value;
            const rcSatellitareCode = result.properties[34].code;
            const rcSatellitareValue = result.properties[34].value;
            const satOutsourcing = result.properties[35].value;
            const satProprieta = result.properties[36].value;
            const satServizi = result.properties[37].value;
            const satSconti = result.properties[38].value;
            const rcRivalsaValue = result.properties[39].value;
            const rcRivalsaValues = result.properties[39].values;
            const rivalsaEbrezza = result.properties[40].value;
            const rivalsaStupefacenti = result.properties[41].value;
            const rivalsaTerzi = result.properties[42].value;
            const rivalsaPatente = result.properties[43].value;
            const rivalsaMinori = result.properties[44].value;
            const rivalsaRevisione = result.properties[45].value;
            const rivalsaNeopatentati = result.properties[46].value;
            const rivalsaAcquisto = result.properties[47].value;
            const rcMerito = result.properties[48].value;
            const rcSpecifica = result.properties[49].value;
            const rcSospensione = result.properties[50].value;
            const rcRicorso = result.properties[51].value;
            const ifIncendio = result.properties[52].value;
            const ifFurto = result.properties[53].value;
            const ifVincoli = result.properties[54].value;
            const ifTotale = result.properties[55].value;
            const ifParziale = result.properties[56].value;
            const ifProporzionale = result.properties[57].value;
            const ifTerzi = result.properties[58].value;
            const kaskoCollisioneValue = result.properties[59].value;
            const kaskoCollisioneValues = result.properties[59].values;
            const collPlafDenominazione = result.properties[60].value;
            const collPlafEventi = result.properties[61].value;
            const collPlafVincoli = result.properties[62].value;
            const collPlafMassimali = result.properties[63].value;
            const collPlafFranchigie = result.properties[64].value;
            const collEventi = result.properties[65].value;
            const collVincoli = result.properties[66].value;
            const collTotale = result.properties[67].value;
            const collParziale = result.properties[68].value;
            const collFranchigie = result.properties[69].value;
            const kaskoEventi = result.properties[70].value;
            const kaskoVincoli = result.properties[71].value;
            const kaskoTotale = result.properties[72].value;
            const kaskoParziale = result.properties[73].value;
            const kaskoFranchigie = result.properties[74].value;
            const attiVandaliciEventi = result.properties[75].value;
            const attiVandaliciVincoli = result.properties[76].value;
            const attiVandaliciFranchigie = result.properties[77].value;
            const eventiNaturaliEventi = result.properties[78].value;
            const eventiNaturaliVincoli = result.properties[79].value;
            const eventiNaturaliFranchigie = result.properties[80].value;
            const eventiSociopoliticiEventi = result.properties[81].value;
            const eventiSociopoliticiVincoli = result.properties[82].value;
            const eventiSociopoliticiFranchigie = result.properties[83].value;
            const cristalliEventi = result.properties[84].value;
            const cristalliVincoli = result.properties[85].value;
            const cristalliMassimali = result.properties[86].value;
            const cristalliFranchigie = result.properties[87].value;
            const assistenzaTipologiaValue = result.properties[88].value;
            const assistenzaTipologiaValues = result.properties[88].values;
            const assistenzaForme = result.properties[89].value;
            const assistenzaMassimali = result.properties[90].value;
            const assistenzaOutsourcing = result.properties[91].value;
            const tutelaLegaleTipologiaValue = result.properties[92].value;
            const tutelaLegaleTipologiaValues = result.properties[92].values;
            const tutelaLegaleForme = result.properties[93].value;
            const tutelaLegaleMassimali = result.properties[94].value;
            const tutelaLegaleOutsourcing = result.properties[95].value;
            const infConducenteTipologiaValue = result.properties[96].value;
            const infConducenteTipologiaValues = result.properties[96].values;
            const infConducenteLimiti = result.properties[97].value;
            const infMorteVincoli = result.properties[98].value;
            const infMorteMassimali = result.properties[99].value;
            const infMorteFranchigie = result.properties[100].value;
            const infInvTabellaCode = result.properties[101].code;
            const infInvTabellaValue = result.properties[101].value;
            const infInvVincoli = result.properties[102].value;
            const infInvMassimali = result.properties[103].value;
            const infInvFranchigie = result.properties[104].value;
            const infInvSopravalutazione = result.properties[105].value;
            const infDiariaVincoli = result.properties[106].value;
            const infDiariaMassimali = result.properties[107].value;
            const infDiariaFranchigie = result.properties[108].value;
            const rimbSpeseGenericheVincoli = result.properties[109].value;
            const rimbSpeseGenericheMassimali = result.properties[110].value;
            const rimbSpeseGenericheFranchigie = result.properties[111].value;
            const rimbSpeseInterventoVincoli = result.properties[112].value;
            const rimbSpeseInterventoMassimali = result.properties[113].value;
            const rimbSpeseInterventoFranchigie = result.properties[114].value;
            const rimbSpeseRicoveroVincoli = result.properties[115].value;
            const rimbSpeseRicoveroMassimali = result.properties[116].value;
            const rimbSpeseRicoveroFranchigie = result.properties[117].value;
            const infMobilitaVincoli = result.properties[118].value;
            const infMobilitaMassimali = result.properties[119].value;
            const infMobilitaFranchigie = result.properties[120].value;
            const inabilitaVincoli = result.properties[121].value;
            const inabilitaMassimali = result.properties[122].value;
            const inabilitaFranchigie = result.properties[123].value;
            const infConducenteAltro = result.properties[124].value;
            const altreGaranzie = result.properties[125].value;
            const innovazione = result.properties[126].value;
            const note = result.properties[127].value;

            properties.prodottoProperty.value = prodotto;
            selectChoices.tariffe = vm.prefillCodeValue(properties.tariffeProperty, tariffeCode, tariffeValue, selectChoices.tariffe, vm.tariffeOptions);
            properties.codProdCollegatoProperty.value = codProdCollegato;
            selectChoices.compagnia = vm.prefillCodeValue(properties.compagniaProperty, compagniaCode, compagniaValue, selectChoices.compagnia, vm.compagniaOptions);
            properties.canaleProperty.value = canaleValue;
            selectChoices.canale = vm.prefillValues(properties.canaleProperty, canaleValues, selectChoices.canale, vm.canaleOptions);
            properties.distributoriProperty.stringList = distributoriStringList;
            properties.modDistribuzioneProperty.value = modDistribuzioneValue;
            selectChoices.modDistribuzione = vm.prefillValues(properties.modDistribuzioneProperty, modDistribuzioneValues, selectChoices.modDistribuzione, vm.modDistribuzioneOptions);
            properties.mercatoProperty.value = mercatoValue;
            selectChoices.mercato = vm.prefillValues(properties.mercatoProperty, mercatoValues, selectChoices.mercato, vm.mercatoOptions);
            properties.destinatariProperty.value = destinatari;
            properties.targetMarketProperty.value = targetMarket;
            properties.descProdottoProperty.value = descProdotto;
            properties.lineaBusinessProperty.value = lineaBusiness;
            selectChoices.veicoli = vm.prefillCodeValue(properties.veicoliProperty, veicoliCode, veicoliValue, selectChoices.veicoli, vm.veicoliOptions);
            selectChoices.prodCommercio = vm.prefillCodeValue(properties.prodCommercioProperty, prodCommercioCode, prodCommercioValue, selectChoices.prodCommercio, vm.prodCommercioOptions);
            properties.inizioCommProperty.value = inizioComm;
            properties.inizioCommProperty.dateValue = vm.dateFromString(inizioComm);
            properties.fineCommProperty.value = fineComm;
            properties.fineCommProperty.dateValue = vm.dateFromString(fineComm);
            properties.edizioneDIPAggProperty.value = edizioneDIPAgg;
            properties.edizioneDIPAggProperty.dateValue = vm.dateFromString(edizioneDIPAgg);
            selectChoices.tipoAssicurazione = vm.prefillCodeValue(properties.tipoAssicurazioneProperty, tipoAssicurazioneCode, tipoAssicurazioneValue, selectChoices.tipoAssicurazione, vm.tipoAssicurazioneOptions);
            properties.durataProperty.value = durata;
            properties.tacitoRinnovoProperty.value = tacitoRinnovo;
            selectChoices.combGaranzieTipologia = vm.prefillCodeValue(properties.combGaranzieTipologiaProperty, combGaranzieTipologiaCode, combGaranzieTipologiaValue, selectChoices.combGaranzieTipologia, vm.combGaranzieTipologiaOptions);
            properties.combGaranzieDescProperty.value = combGaranzieDesc;
            properties.premioTipologiaProperty.value = premioTipologiaValue;
            selectChoices.premioTipologia = vm.prefillValues(properties.premioTipologiaProperty, premioTipologiaValues, selectChoices.premioTipologia, vm.premioTipologiaOptions);
            properties.premioDescProperty.value = premioDesc;
            properties.frazPremioProperty.value = frazPremioValue;
            selectChoices.frazPremio = vm.prefillValues(properties.frazPremioProperty, frazPremioValues, selectChoices.frazPremio, vm.frazPremioOptions);
            properties.interessiFrazProperty.value = interessiFrazValue;
            properties.interessiFrazProperty.frazionamento = interessiFrazFrazionamento;
            if (retrDistrSign === undefined || retrDistrSign === null) {
              retrDistrSign = "%";
            }
            properties.retrDistrProperty.value = retrDistr;
            properties.retrDistrProperty.valueSign = retrDistrSign;
            vm.retrDistrField.value = retrDistr;
            vm.retrDistrField.valueSign = retrDistrSign;
            properties.retrDistrSpecificheProperty.value = retrDistrSpecifiche;
            properties.rischiProperty.value = rischiValue;
            selectChoices.rischi = vm.prefillValues(properties.rischiProperty, rischiValues, selectChoices.rischi, vm.rischiOptions);
            properties.rcTarifProperty.value = rcTarifValue;
            selectChoices.rcTarif = vm.prefillValues(properties.rcTarifProperty, rcTarifValues, selectChoices.rcTarif, vm.rcTarifOptions);
            properties.rcGuidaProperty.value = rcGuidaValue;
            selectChoices.rcGuida = vm.prefillValues(properties.rcGuidaProperty, rcGuidaValues, selectChoices.rcGuida, vm.rcGuidaOptions);
            properties.guidaLiberaProperty.value = guidaLibera;
            properties.guidaEspertaProperty.value = guidaEsperta;
            properties.guidaEsclusivaProperty.value = guidaEsclusiva;
            selectChoices.rcSatellitare = vm.prefillCodeValue(properties.rcSatellitareProperty, rcSatellitareCode, rcSatellitareValue, selectChoices.rcSatellitare, vm.rcSatellitareOptions);
            properties.satOutsourcingProperty.value = satOutsourcing;
            properties.satProprietaProperty.value = satProprieta;
            properties.satServiziProperty.value = satServizi;
            properties.satScontiProperty.value = satSconti;
            properties.rcRivalsaProperty.value = rcRivalsaValue;
            selectChoices.rcRivalsa = vm.prefillValues(properties.rcRivalsaProperty, rcRivalsaValues, selectChoices.rcRivalsa, vm.rcRivalsaOptions);
            properties.rivalsaEbrezzaProperty.value = rivalsaEbrezza;
            properties.rivalsaStupefacentiProperty.value = rivalsaStupefacenti;
            properties.rivalsaTerziProperty.value = rivalsaTerzi;
            properties.rivalsaPatenteProperty.value = rivalsaPatente;
            properties.rivalsaMinoriProperty.value = rivalsaMinori;
            properties.rivalsaRevisioneProperty.value = rivalsaRevisione;
            properties.rivalsaNeopatentatiProperty.value = rivalsaNeopatentati;
            properties.rivalsaAcquistoProperty.value = rivalsaAcquisto;
            properties.rcMeritoProperty.value = rcMerito;
            properties.rcSpecificaProperty.value = rcSpecifica;
            properties.rcSospensioneProperty.value = rcSospensione;
            properties.rcRicorsoProperty.value = rcRicorso;
            properties.ifIncendioProperty.value = ifIncendio;
            properties.ifFurtoProperty.value = ifFurto;
            properties.ifVincoliProperty.value = ifVincoli;
            properties.ifTotaleProperty.value = ifTotale;
            properties.ifParzialeProperty.value = ifParziale;
            properties.ifProporzionaleProperty.value = ifProporzionale;
            properties.ifTerziProperty.value = ifTerzi;
            properties.kaskoCollisioneProperty.value = kaskoCollisioneValue;
            selectChoices.kaskoCollisione = vm.prefillValues(properties.kaskoCollisioneProperty, kaskoCollisioneValues, selectChoices.kaskoCollisione, vm.kaskoCollisioneOptions);
            properties.collPlafDenominazioneProperty.value = collPlafDenominazione;
            properties.collPlafEventiProperty.value = collPlafEventi;
            properties.collPlafVincoliProperty.value = collPlafVincoli;
            properties.collPlafMassimaliProperty.value = collPlafMassimali;
            properties.collPlafFranchigieProperty.value = collPlafFranchigie;
            properties.collEventiProperty.value = collEventi;
            properties.collVincoliProperty.value = collVincoli;
            properties.collTotaleProperty.value = collTotale;
            properties.collParzialeProperty.value = collParziale;
            properties.collFranchigieProperty.value = collFranchigie;
            properties.kaskoEventiProperty.value = kaskoEventi;
            properties.kaskoVincoliProperty.value = kaskoVincoli;
            properties.kaskoTotaleProperty.value = kaskoTotale;
            properties.kaskoParzialeProperty.value = kaskoParziale;
            properties.kaskoFranchigieProperty.value = kaskoFranchigie;
            properties.attiVandaliciEventiProperty.value = attiVandaliciEventi;
            properties.attiVandaliciVincoliProperty.value = attiVandaliciVincoli;
            properties.attiVandaliciFranchigieProperty.value = attiVandaliciFranchigie;
            properties.eventiNaturaliEventiProperty.value = eventiNaturaliEventi;
            properties.eventiNaturaliVincoliProperty.value = eventiNaturaliVincoli;
            properties.eventiNaturaliFranchigieProperty.value = eventiNaturaliFranchigie;
            properties.eventiSociopoliticiEventiProperty.value = eventiSociopoliticiEventi;
            properties.eventiSociopoliticiVincoliProperty.value = eventiSociopoliticiVincoli;
            properties.eventiSociopoliticiFranchigieProperty.value = eventiSociopoliticiFranchigie;
            properties.cristalliEventiProperty.value = cristalliEventi;
            properties.cristalliVincoliProperty.value = cristalliVincoli;
            properties.cristalliMassimaliProperty.value = cristalliMassimali;
            properties.cristalliFranchigieProperty.value = cristalliFranchigie;
            properties.assistenzaTipologiaProperty.value = assistenzaTipologiaValue;
            selectChoices.assistenzaTipologia = vm.prefillValues(properties.assistenzaTipologiaProperty, assistenzaTipologiaValues, selectChoices.assistenzaTipologia, vm.assistenzaTipologiaOptions);
            vm.altroAssistenzaTipologia = vm.getAltroDescription(properties.assistenzaTipologiaProperty, '85.51', vm.assistenzaTipologiaOptions);
            properties.assistenzaFormeProperty.value = assistenzaForme;
            properties.assistenzaMassimaliProperty.value = assistenzaMassimali;
            properties.assistenzaOutsourcingProperty.value = assistenzaOutsourcing;
            properties.tutelaLegaleTipologiaProperty.value = tutelaLegaleTipologiaValue;
            selectChoices.tutelaLegaleTipologia = vm.prefillValues(properties.tutelaLegaleTipologiaProperty, tutelaLegaleTipologiaValues, selectChoices.tutelaLegaleTipologia, vm.tutelaLegaleTipologiaOptions);
            vm.altroTutelaLegaleTipologia = vm.getAltroDescription(properties.tutelaLegaleTipologiaProperty, '91.29', vm.tutelaLegaleTipologiaOptions);
            properties.tutelaLegaleFormeProperty.value = tutelaLegaleForme;
            properties.tutelaLegaleMassimaliProperty.value = tutelaLegaleMassimali;
            properties.tutelaLegaleOutsourcingProperty.value = tutelaLegaleOutsourcing;
            properties.infConducenteTipologiaProperty.value = infConducenteTipologiaValue;
            selectChoices.infConducenteTipologia = vm.prefillValues(properties.infConducenteTipologiaProperty, infConducenteTipologiaValues, selectChoices.infConducenteTipologia, vm.infConducenteTipologiaOptions);
            properties.infConducenteLimitiProperty.value = infConducenteLimiti;
            properties.infMorteVincoliProperty.value = infMorteVincoli;
            properties.infMorteMassimaliProperty.value = infMorteMassimali;
            properties.infMorteFranchigieProperty.value = infMorteFranchigie;
            selectChoices.infInvTabella = vm.prefillCodeValue(properties.infInvTabellaProperty, infInvTabellaCode, infInvTabellaValue, selectChoices.infInvTabella, vm.infInvTabellaOptions);
            properties.infInvVincoliProperty.value = infInvVincoli;
            properties.infInvMassimaliProperty.value = infInvMassimali;
            properties.infInvFranchigieProperty.value = infInvFranchigie;
            properties.infInvSopravalutazioneProperty.value = infInvSopravalutazione;
            properties.infDiariaVincoliProperty.value = infDiariaVincoli;
            properties.infDiariaMassimaliProperty.value = infDiariaMassimali;
            properties.infDiariaFranchigieProperty.value = infDiariaFranchigie;
            properties.rimbSpeseGenericheVincoliProperty.value = rimbSpeseGenericheVincoli;
            properties.rimbSpeseGenericheMassimaliProperty.value = rimbSpeseGenericheMassimali;
            properties.rimbSpeseGenericheFranchigieProperty.value = rimbSpeseGenericheFranchigie;
            properties.rimbSpeseInterventoVincoliProperty.value = rimbSpeseInterventoVincoli;
            properties.rimbSpeseInterventoMassimaliProperty.value = rimbSpeseInterventoMassimali;
            properties.rimbSpeseInterventoFranchigieProperty.value = rimbSpeseInterventoFranchigie;
            properties.rimbSpeseRicoveroVincoliProperty.value = rimbSpeseRicoveroVincoli;
            properties.rimbSpeseRicoveroMassimaliProperty.value = rimbSpeseRicoveroMassimali;
            properties.rimbSpeseRicoveroFranchigieProperty.value = rimbSpeseRicoveroFranchigie;
            properties.infMobilitaVincoliProperty.value = infMobilitaVincoli;
            properties.infMobilitaMassimaliProperty.value = infMobilitaMassimali;
            properties.infMobilitaFranchigieProperty.value = infMobilitaFranchigie;
            properties.inabilitaVincoliProperty.value = inabilitaVincoli;
            properties.inabilitaMassimaliProperty.value = inabilitaMassimali;
            properties.inabilitaFranchigieProperty.value = inabilitaFranchigie;
            properties.infConducenteAltroProperty.value = infConducenteAltro;
            properties.altreGaranzieProperty.value = altreGaranzie;
            properties.innovazioneProperty.value = innovazione;
            properties.noteProperty.value = note;
          })
          .catch(() => {
            vm.openModalError();
          })

        vm.stopLoading();
      } else {
        vm.changeTariffe();
        vm.changeFineComm();
        vm.changePremioTipologia();
        vm.changeFrazPremio();
        vm.changeRischi();
      }

      vm.stopLoading();
    },
    setDatePropertiesValue() {
      const vm = this as any;

      properties.inizioCommProperty.value = vm.formatDate(properties.inizioCommProperty.dateValue);
      if (properties.prodCommercioProperty.code == "12.2") {
        properties.fineCommProperty.value = vm.formatDate(properties.fineCommProperty.dateValue);
      }
      properties.edizioneDIPAggProperty.value = vm.formatDate(properties.edizioneDIPAggProperty.dateValue);
    },
    setAltroDescription: function(property: any, options: any, altroCode: string, altroSpecificValue: string) {
      const vm = this as any;

      let cleanValue = "";
      for (let i = 0; i < options.length; i++) {
        if (options[i].code == altroCode) {
          cleanValue = options[i].description;
        }
      }
      for (let i = 0; i < property.values.length; i++) {
        if (property.values[i].code == altroCode) {
          property.values[i].description = cleanValue + " " + altroSpecificValue;
        }
      }
    },
    getAltroDescription: function(property: any, optionCode: string, options: any) {
      let optionDescription = "";
      for (let i = 0; i < options.length; i++) {
        if (options[i].code == optionCode) {
          optionDescription = options[i].description + " ";
        }
      }
      for (let i = 0; i < property.values.length; i++) {
        const propIValue = property.values[i] as any;
        if (propIValue.code == optionCode) {
          return propIValue.description.substring(optionDescription.length);
        }
      }
      return undefined;
    },
    preparePropList() {
      const vm = this as any;

      vm.setAltroDescription(properties.assistenzaTipologiaProperty,vm.assistenzaTipologiaOptions,"85.51",vm.altroAssistenzaTipologia);
      vm.setAltroDescription(properties.tutelaLegaleTipologiaProperty,vm.tutelaLegaleTipologiaOptions,"91.29",vm.altroTutelaLegaleTipologia);

      vm.setDatePropertiesValue();

      properties.retrDistrProperty.value = vm.retrDistrField.value;
      properties.retrDistrProperty.valueSign = vm.retrDistrField.valueSign;

      vm.propList = [
        properties.prodottoProperty,
        properties.tariffeProperty,
        properties.codProdCollegatoProperty,
        properties.compagniaProperty,
        properties.canaleProperty,
        properties.distributoriProperty,
        properties.modDistribuzioneProperty,
        properties.mercatoProperty,
        properties.destinatariProperty,
        properties.targetMarketProperty,
        properties.descProdottoProperty,
        properties.lineaBusinessProperty,
        properties.veicoliProperty,
        properties.combGaranzieTipologiaProperty,
        properties.combGaranzieDescProperty,
        properties.prodCommercioProperty,
        properties.inizioCommProperty,
        properties.fineCommProperty,
        properties.edizioneDIPAggProperty,
        properties.tipoAssicurazioneProperty,
        properties.durataProperty,
        properties.tacitoRinnovoProperty,
        properties.premioTipologiaProperty,
        properties.premioDescProperty,
        properties.frazPremioProperty,
        properties.interessiFrazProperty,
        properties.retrDistrProperty,
        properties.retrDistrSpecificheProperty,
        properties.rischiProperty,
        properties.rcTarifProperty,
        properties.rcGuidaProperty,
        properties.guidaLiberaProperty,
        properties.guidaEspertaProperty,
        properties.guidaEsclusivaProperty,
        properties.rcSatellitareProperty,
        properties.satOutsourcingProperty,
        properties.satProprietaProperty,
        properties.satServiziProperty,
        properties.satScontiProperty,
        properties.rcRivalsaProperty,
        properties.rivalsaEbrezzaProperty,
        properties.rivalsaStupefacentiProperty,
        properties.rivalsaTerziProperty,
        properties.rivalsaPatenteProperty,
        properties.rivalsaMinoriProperty,
        properties.rivalsaRevisioneProperty,
        properties.rivalsaNeopatentatiProperty,
        properties.rivalsaAcquistoProperty,
        properties.rcMeritoProperty,
        properties.rcSpecificaProperty,
        properties.rcSospensioneProperty,
        properties.rcRicorsoProperty,
        properties.ifIncendioProperty,
        properties.ifFurtoProperty,
        properties.ifVincoliProperty,
        properties.ifTotaleProperty,
        properties.ifParzialeProperty,
        properties.ifProporzionaleProperty,
        properties.ifTerziProperty,
        properties.kaskoCollisioneProperty,
        properties.collPlafDenominazioneProperty,
        properties.collPlafEventiProperty,
        properties.collPlafVincoliProperty,
        properties.collPlafMassimaliProperty,
        properties.collPlafFranchigieProperty,
        properties.collEventiProperty,
        properties.collVincoliProperty,
        properties.collTotaleProperty,
        properties.collParzialeProperty,
        properties.collFranchigieProperty,
        properties.kaskoEventiProperty,
        properties.kaskoVincoliProperty,
        properties.kaskoTotaleProperty,
        properties.kaskoParzialeProperty,
        properties.kaskoFranchigieProperty,
        properties.attiVandaliciEventiProperty,
        properties.attiVandaliciVincoliProperty,
        properties.attiVandaliciFranchigieProperty,
        properties.eventiNaturaliEventiProperty,
        properties.eventiNaturaliVincoliProperty,
        properties.eventiNaturaliFranchigieProperty,
        properties.eventiSociopoliticiEventiProperty,
        properties.eventiSociopoliticiVincoliProperty,
        properties.eventiSociopoliticiFranchigieProperty,
        properties.cristalliEventiProperty,
        properties.cristalliVincoliProperty,
        properties.cristalliMassimaliProperty,
        properties.cristalliFranchigieProperty,
        properties.assistenzaTipologiaProperty,
        properties.assistenzaFormeProperty,
        properties.assistenzaMassimaliProperty,
        properties.assistenzaOutsourcingProperty,
        properties.tutelaLegaleTipologiaProperty,
        properties.tutelaLegaleFormeProperty,
        properties.tutelaLegaleMassimaliProperty,
        properties.tutelaLegaleOutsourcingProperty,
        properties.infConducenteTipologiaProperty,
        properties.infConducenteLimitiProperty,
        properties.infMorteVincoliProperty,
        properties.infMorteMassimaliProperty,
        properties.infMorteFranchigieProperty,
        properties.infInvTabellaProperty,
        properties.infInvVincoliProperty,
        properties.infInvMassimaliProperty,
        properties.infInvFranchigieProperty,
        properties.infInvSopravalutazioneProperty,
        properties.infDiariaVincoliProperty,
        properties.infDiariaMassimaliProperty,
        properties.infDiariaFranchigieProperty,
        properties.rimbSpeseGenericheVincoliProperty,
        properties.rimbSpeseGenericheMassimaliProperty,
        properties.rimbSpeseGenericheFranchigieProperty,
        properties.rimbSpeseInterventoVincoliProperty,
        properties.rimbSpeseInterventoMassimaliProperty,
        properties.rimbSpeseInterventoFranchigieProperty,
        properties.rimbSpeseRicoveroVincoliProperty,
        properties.rimbSpeseRicoveroMassimaliProperty,
        properties.rimbSpeseRicoveroFranchigieProperty,
        properties.infMobilitaVincoliProperty,
        properties.infMobilitaMassimaliProperty,
        properties.infMobilitaFranchigieProperty,
        properties.inabilitaVincoliProperty,
        properties.inabilitaMassimaliProperty,
        properties.inabilitaFranchigieProperty,
        properties.infConducenteAltroProperty,
        properties.altreGaranzieProperty,
        properties.innovazioneProperty,
        properties.noteProperty,
      ];
    },
    selectedFile: function(fileList: any[]) {
      if (!fileList.length) return;
      this.massiveFile = fileList[0];
    },
    uploadMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.uploadMassive(categories.DANNI_AUTO, vm.massiveFile)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          if (result !== undefined) {
            vm.massiveLoaded = true;
            vm.massiveResult = result;
          } else {
            vm.closeModalMassivo();
            vm.openModalError("Non è stato possibile caricare il file.");
          }
        })
        .catch(() => {
          vm.stopLoading();
          vm.openModalError("Non è stato possibile caricare il file.");
        });
    },
    confirmMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.confirmMassive(vm.massiveResult.massiveId)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          vm.closeModalMassivo();
          vm.openModalError("Prodotti caricati.", "OK"); // non è un errore, sfrutto per aprire la modale
        })
        .catch(() => {
          vm.stopLoading();
          vm.openModalError("Non è stato possibile confermare i dati caricati.");
        });
    },
    deleteMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.deleteMassive(vm.massiveResult.massiveId)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          vm.closeModalMassivo();
          vm.openModalError("Caricamento massivo annullato.", "OK"); // non è un errore, sfrutto per aprire la modale
        })
        .catch(() => {
          vm.stopLoading();
          vm.closeModalMassivo();
        });
    },
    printVersatileValues(property: any) {
      const vm = this as any;

      let isPrintStringList = false;
      if (property.type == propertyTypes.STRING_LIST) {
        isPrintStringList = true;
      } else if (property.stringList !== undefined && property.stringList !== null) {
        if (property.stringList.length > 0) {
          isPrintStringList = true;
        }
      }

      let printableValue = "";
      let tooltipValue = "";
      if (property.type == propertyTypes.VALUES) {
        if (property.values.length > 0) {
          //property.values.sort(this._compare);
          if (property.values.length == 1) {
            const item = property.values[0];
            printableValue = item.description;
          } else {
            const maxLi = 3;
            let liCounter = 0;
            let li = "";
            // printableValue & tooltipValue
            const tooltipLi = property.values.map(function(item: any) {
              //li is a subset of what in tooltipLi (all)
              liCounter++;
              if (liCounter < maxLi) {
                li += "<li>" + item.description + "</li>";
              } else if (liCounter == maxLi) {
                li += "<li>" + '...' + "</li>";
              }
              return "<li>" + item.description + "</li>";
            }).join("");

            printableValue = "<div><ul class='dashed'>" + li + "</ul><div>";
            if (liCounter >= maxLi) {
              tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul><div>";
            }
          }
        } else {
          printableValue = property.value;
        }
      } else if (isPrintStringList) {
        if (property.value !== "") {
          printableValue = property.value;
        } else if (property.stringList.length == 1) {
          const item = property.stringList[0];
          printableValue = vm.printStringListItem(item);
        } else {
          const maxLi = 3;
          let liCounter = 0;
          let li = "";
          // printableValue & tooltipValue
          const tooltipLi = property.stringList.map(function(item: any) {
            //li is a subset of what in tooltipLi (all)
            liCounter++;
            if (liCounter < maxLi) {
              li += "<li>" + item.value + item.valueSign + "</li>";
            } else if (liCounter == maxLi) {
              li += "<li>" + '...' + "</li>";
            }
            return "<li>" + item.value + item.valueSign + "</li>";
          }).join("");

          printableValue = "<div><ul class='dashed'>" + li + "</ul><div>";
          if (liCounter >= maxLi) {
            tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul><div>";
          }
        }
      } else if (property.type == propertyTypes.FRAZIONAMENTO) {
        if (property.value === vm.ND) {
          printableValue = property.value;
        } else {
          let values = [];
          if (property.frazionamento.mensile !== vm.ND) {
            values.push("Mensile: " + property.frazionamento.mensile + property.frazionamento.mensileSign);
          }
          if (property.frazionamento.bimestrale !== vm.ND) {
            values.push("Bimestrale: " + property.frazionamento.bimestrale + property.frazionamento.bimestraleSign);
          }
          if (property.frazionamento.trimestrale !== vm.ND) {
            values.push("Trimestrale: " + property.frazionamento.trimestrale + property.frazionamento.trimestraleSign);
          }
          if (property.frazionamento.quadrimestrale !== vm.ND) {
            values.push("Quadrimestrale: " + property.frazionamento.quadrimestrale + property.frazionamento.quadrimestraleSign);
          }
          if (property.frazionamento.semestrale !== vm.ND) {
            values.push("Semestrale: " + property.frazionamento.semestrale + property.frazionamento.semestraleSign);
          }
          if (values.length == 1) {
            printableValue = values[0];
          } else if (values.length > 1) {
            const maxLi = 3;
            let liCounter = 0;
            let li = "";
            const tooltipLi = values.map(function(s: any) {
              liCounter++;
              if (liCounter < maxLi) {
                li += "<li>" + s + "</li>";
              } else if (liCounter == maxLi) {
                li += "<li>" + '...' + "</li>";
              }
              return "<li>" + s + "</li>";
            }).join("");
            printableValue = "<ul class='dashed'>" + li + "</ul>"
            if (liCounter >= maxLi) {
              tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul><div>";
            }
          }
        }
      } else if (property.type == propertyTypes.DATE) {
        const d = vm.dateFromString(property.value);
        if (d != null) {
          printableValue = vm.formatDateF(d, "MM/yyyy");
        } else {
          printableValue = property.value;
        }
      } else {
        const maxCharsPerRow = 40;
        const maxRows = 1;
        let printedRows = 0;
        let flagDots = false;
        if (property.value !== undefined && property.value !== null) {
          if (property.value.length > maxCharsPerRow) {

            for (let i = 0; i < property.value.length && printedRows < maxRows;) {
              let endIndex = Math.min(i+maxCharsPerRow, property.value.length);
              let dots = "";
              if (printedRows+1 == maxRows) {
                dots = "...";
                flagDots = true;
              }
              printableValue += "<div>" + property.value.substring(i, endIndex) + dots + "</div>";
              i += maxCharsPerRow;
              printedRows += 1;
            }

            if (flagDots) {
              tooltipValue = property.value;
            }
          } else {
            printableValue = property.value;
          }
        }
      }

      if (tooltipValue !== undefined && !vm.isEmptyOrSpaces(tooltipValue)) {
        printableValue = tooltipValue;
      }

      printableValue = printableValue.replace(/\n/g, "<br />");

      return printableValue;
    },
    //
    inserisciProdotto: async function() {
      const vm = this as any;
      vm.startLoading();
      let productId = undefined;

      if (vm.productIdSelected === undefined) {
        let nuovoProdotto = {} as any;
        nuovoProdotto = await vm.registraProdotto();
        if (nuovoProdotto == undefined) {
          vm.stopLoading();
          vm.openModalError();
        } else {
          productId = nuovoProdotto.productId;
        }
      } else {
        productId = vm.productIdSelected;
      }

      if (productId === undefined) {
        vm.stopLoading();
        vm.openModalError();
      } else {
        //FINE FUNZIONI DI MAPPING
        vm.valorizzaTendine();

        vm.setDatePropertiesValue();

        vm.setPropertiesDefaultCode();

        vm.preparePropList();

        const serviceCallReturnValue = await requestService
          .addProductPropertyList({
            productId: productId,
            propertyList: vm.propList
          })
          .then(handleResponse)
          .then((result: any) => {
            if (!isNil(result.productId)) {
              vm.esitoRegistrazione = "Registrazione avvenuta con successo";
            } else {
              vm.esitoRegistrazione = "Registrazione KO";
            }

            return result.productId;
          })
          .catch(() => {
            vm.openModalError();
          });

        vm.stopLoading();

        vm.closeModalConfirm();

        vm.openModalConfirmOutcome();
      }
    },
    registraProdotto: async function() {
      return requestService.initProductWithCategory(categories.DANNI_AUTO).then(handleResponse);
    },
    _compareDesc: function(a: any, b: any) {
      const aDesc = a.description;
      const bDesc = b.description;
      if (aDesc === undefined || bDesc === undefined) {
        if (bDesc !== undefined) {
          return -1;
        }
        if (aDesc !== undefined) {
          return 1;
        }
        return 0;
      }

      if (aDesc > bDesc) {
        return 1;
      } else {
        return -1;
      }
    },
    isAdmin: function() {
      const vm = this as any;
      const isAdmin = vm.loggedUser.roles.indexOf('admin') >= 0;
      const isAdminView = vm.loggedUser.roles.indexOf('admin-view') >= 0;
      return isAdmin || isAdminView;
    },
    massivo: function() {
      const vm = this as any;
      const isAdmin = vm.loggedUser.roles.indexOf('admin') >= 0;
      const isMassivo = vm.loggedUser.roles.indexOf('massivo') >= 0;

      return isAdmin || isMassivo;
    },
  },
  created() {
    const vm = this as any;

    // sort compagnie by desc
    vm.compagniaOptions.sort(vm._compareDesc);

    vm.cleanAllProperties();

    vm.prefillProperties();
  },
  mounted() {
    const vm = this as any;
    if (!vm.loggedUser) {
      vm.home();
    } else {
      const hasRole = vm.loggedUser.roles.indexOf('danni-auto') >= 0;

      if (!vm.isAdmin() && !hasRole) {
        vm.home();
      }
    }
  },
  destroyed() {
    const vm = this as any;
    //vm.stopLoading();
    vm.closeModalError();
  },  
});
